import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);

export function LeadsPipelineStagesCard() {
  const [filter, setFilter] = useState("2023 - 2024");

  const labels = [
    "Jan","Feb","Mar","Apr","May","Jun",
    "Jul","Aug","Sep","Oct","Nov","Dec"
  ];

  // 🔥 MULTIPLE DATASETS (YEAR BASED)
  const datasetMap = {
    "2023 - 2024": {
      contacted: [25,25,25,25,25,25,25,25,25,25,20,25],
      opportunity: [30,5,20,30,30,30,30,30,30,30,0,30],
      notContacted: [5,0,0,25,30,35,25,25,25,30,0,25],
    },
    "2022 - 2023": {
      contacted: [20,20,20,20,20,20,20,20,20,20,15,20],
      opportunity: [20,10,15,20,25,25,25,25,25,25,5,25],
      notContacted: [10,5,5,15,20,20,20,20,20,20,5,20],
    },
    "2021 - 2022": {
      contacted: [15,15,15,15,15,15,15,15,15,15,10,15],
      opportunity: [10,10,10,10,10,10,10,10,10,10,5,10],
      notContacted: [5,5,5,5,5,5,5,5,5,5,5,5],
    }
  };

  const selected = datasetMap[filter];

  //  CALCULATE REMAINING (100 - total)
  const remaining = selected.contacted.map((v, i) => {
    const total =
      v +
      selected.opportunity[i] +
      selected.notContacted[i];
    return 100 - total;
  });

  const data = {
    labels,
    datasets: [
      {
        label: "Contacted",
        data: selected.contacted,
        backgroundColor: "#f97316",
        stack: "stack1",
        borderRadius: 8,
        barThickness: 35,
      },
      {
        label: "Opportunity",
        data: selected.opportunity,
        backgroundColor: "#0f3d4c",
        stack: "stack1",
        barThickness: 35,
      },
      {
        label: "Not Contacted",
        data: selected.notContacted,
        backgroundColor: "#3b82f6",
        stack: "stack1",
        barThickness: 35,
      },
      {
        label: "Remaining",
        data: remaining,
        backgroundColor: "#e5e7eb",
        stack: "stack1",
        barThickness: 35,
        borderRadius: 8,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: { display: false },

      // 🔥 CUSTOM TOOLTIP EXACT DESIGN
      tooltip: {
        backgroundColor: "#fff",
        borderColor: "#3b82f6",
        borderWidth: 1,
        titleColor: "#111",
        bodyColor: "#111",
        padding: 12,
        displayColors: true,
        callbacks: {
          title: (items) => items[0].label,
          label: (ctx) => {
            const value = ctx.raw;
            const label = ctx.dataset.label;
            return `${label}: ${value} k`;
          },
        },
      },
    },

    scales: {
      x: {
        stacked: true,
        grid: { display: false },
        ticks: { color: "#6b7280" },
      },
      y: {
        stacked: true,
        max: 100,
        ticks: {
          stepSize: 20,
          callback: (v) => v + "K",
          color: "#6b7280",
        },
        grid: {
          color: "#f3f4f6",
        },
      },
    },
  };

  return (
    <Card className="ps-card h-100">
      <Card.Header className="ps-header card-header-custom">
        <h5>Pipeline Stages</h5>

        <Dropdown>
          <Dropdown.Toggle className="ps-btn ps-toggle text-dark">
            <FiCalendar className="me-1" />
            {filter}
          </Dropdown.Toggle>

          <Dropdown.Menu align="end" className="ps-menu">
            {Object.keys(datasetMap).map((item) => (
              <Dropdown.Item
                key={item}
                onClick={() => setFilter(item)}
              >
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      <Card.Body>
        {/* TOP STATS */}
        <div className="ps-top justify-content-betweeen align-item-center">
          <div className=" border rounded rounded-3 p-3">
            <span className="dot orange"></span> Contacted
            <b> 50000</b>
          </div>
          <div className=" border rounded rounded-3 p-3" >
            <span className="dot dark"></span> Opportunity
            <b> 25985</b>
          </div>
          <div className=" border rounded rounded-3 p-3" >
            <span className="dot blue"></span> Not Contacted
            <b> 12566</b>
          </div>
        </div>

        <div style={{ height: "260px" }}>
          <Bar data={data} options={options} />
        </div>
      </Card.Body>

      <style>{`
        .ps-card {
          border:2px solid #e5e7eb;
          border-radius:5px;
        }
               .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}

        .ps-header {
          display:flex;
          justify-content:space-between;
          align-items:center;
        }

        .ps-btn {
          background:#fff;
          border:1px solid #e5e7eb;
          font-size:14px;
          padding:6px 10px;
        }
          
        .ps-btn:hover {
      border-color: #f97316 !important;
          color: #f97316 !important;
           background: #f9fafb;
          border: 1px solid #e5e7eb;
        }

        .ps-toggle::after { display:none; }

        .ps-menu {
          border-radius:10px;
          padding:10px;
        }

        .ps-top {
          display:flex;
          gap:30px;
          margin-bottom:15px;
          font-size:14px;
          color:#374151;
        }

        .dot {
          width:10px;
          height:10px;
          border-radius:50%;
          display:inline-block;
          margin-right:6px;
        }

        .orange { background:#f97316; }
        .dark { background:#0f3d4c; }
        .blue { background:#3b82f6; }

      `}</style>
    </Card>
  );
}